export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-logotypes/bitcoin-btc-logo-0deec8a26cc4d04d10f39e8925d20ea6.png";